export default __webpack_public_path__ + "static/media/duckfixed.ba05e46f.jpg";